// extracted by mini-css-extract-plugin
export default {"RecipeSelection":"RecipeSelection_RecipeSelection__4w+yB"};